import firebase from 'firebase'
import { getQuantity, getToken } from '../helpers'

const state = {
  continent: null,
  continents: null,
  errorContinent: null,
  coinsBanknotesByContinent: null
}

const mutations = {
  setContinent (state, payload) {
    state.continent = payload
  },
  setContinents (state, payload) {
    state.continents = payload
  },
  setErrorContinent (state, payload) {
    state.errorContinent = payload
  },
  setCoinsBanknotesByContinent (state, payload) {
    state.coinsBanknotesByContinent = payload
  }
}

const actions = {
  fetchContinent ({commit}, payload) {
    firebase.database().ref('continents').orderByChild('code').equalTo(payload.code).once('value')
      .then(snapshot => commit('setContinent', Object.entries(snapshot.val()).map(([key, value]) => ({key, ...value}))[0]))
      .catch(err => commit('setErrorContinent', err.message))
  },
  fetchContinents ({commit}, payload) {
    if (payload !== undefined && payload.withCountries) {
      let promiseContinents = firebase.database().ref('continents').once('value')
      let promiseCountries = firebase.database().ref('countries').once('value')
      let arr = []

      Promise.all([promiseContinents, promiseCountries]).then(data => {
        let continents = data[0] ? data[0].val() : null
        let countries = data[1] ? data[1].val() : null

        let arrCountries = countries ? Object.entries(countries).map(([key, value]) => ({key, ...value})) : []
        let arrContinents = continents ? Object.entries(continents).map(([key, value]) => ({key, ...value})) : []
        if (arrContinents.length > 0) {
          for (let i in arrContinents) {
            arr.push({
              code: arrContinents[i].code,
              countries: arrCountries.filter(country => country.continent === arrContinents[i].code).map(country => country.code)
            })
          }
        }
        commit('setContinents', arr)
      })
    } else {
      firebase.database().ref('continents').once('value')
        .then(snapshot => commit('setContinents', snapshot.val()))
        .catch(err => commit('setErrorContinent', err.message))
    }
  },
  fetchCoinsBanknotesByContinent ({commit}) {
    let tokenUser = getToken()
    if (tokenUser) {
      let promiseCoins = firebase.database().ref('coins').orderByChild('uid').equalTo(tokenUser).once('value')
      let promiseBanknotes = firebase.database().ref('banknotes').orderByChild('uid').equalTo(tokenUser).once('value')
      let promiseContinent = firebase.database().ref('continents').once('value')
      let promiseCountries = firebase.database().ref('countries').once('value')
      let arr = []

      Promise.all([promiseCoins, promiseContinent, promiseBanknotes, promiseCountries]).then(data => {
        let coins = data[0] ? data[0].val() : null
        let continents = data[1] ? data[1].val() : null
        let banknotes = data[2] ? data[2].val() : null
        let countries = data[3] ? data[3].val() : null
        let arrCoins = coins ? Object.entries(coins).map(([key, value]) => ({key, ...value})) : []
        let arrBanknotes = banknotes ? Object.entries(banknotes).map(([key, value]) => ({key, ...value})) : []
        let arrCountries = countries ? Object.entries(countries).map(([key, value]) => ({key, ...value})) : []
        let arrContinents = continents ? Object.entries(continents).map(([key, value]) => ({key, ...value})) : []

        if (arrContinents.length > 0) {
          for (let i in arrContinents) {
            let coinsByContinent = arrCoins.filter(coin => coin.continent === arrContinents[i].code)
            let banknotesByContinent = arrBanknotes.filter(banknote => banknote.continent === arrContinents[i].code)
            let filteredCountries = arrCountries.filter(country => country.continent === arrContinents[i].code)
            arr.push({
              id: arrContinents[i].code,
              name: arrContinents[i].name,
              color: arrContinents[i].color,
              nbCoins: getQuantity(coinsByContinent),
              nbBanknotes: getQuantity(banknotesByContinent),
              coins () {
                let filteredCoins = []
                for (let i in filteredCountries) {
                  let filteredCoinsByCountry = arrCoins.filter(coin => coin.country === filteredCountries[i].code)
                  filteredCoins.push({
                    code: filteredCountries[i].code,
                    country: filteredCountries[i].name,
                    quantity: getQuantity(filteredCoinsByCountry)
                  })
                }
                return filteredCoins
              },
              banknotes () {
                let filteredBanknotes = []
                for (let i in filteredCountries) {
                  let filteredBanknotesByCountry = arrBanknotes.filter(banknote => banknote.country === filteredCountries[i].code)
                  filteredBanknotes.push({
                    code: filteredCountries[i].code,
                    country: filteredCountries[i].name,
                    quantity: getQuantity(filteredBanknotesByCountry)
                  })
                }
                return filteredBanknotes
              }
            })
          }
        }
        commit('setCoinsBanknotesByContinent', arr)
      })
    }
  }
}

const getters = {
  continent (state) {
    return state.continent
  },
  continents (state) {
    return state.continents
  },
  coinsBanknotesByContinent (state) {
    return state.coinsBanknotesByContinent
  },
  errorContinent (state) {
    return state.errorContinent
  }
}

export default {
  namespaces: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/continent.js